import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NO_LOGO } from 'src/app/constants/storage-elements';
import { ROUTES } from 'src/app/route/routes';
import { SessionStorageService } from 'src/app/service/session-storage.service';

@Component({
  selector: 'app-header-landing',
  templateUrl: './header-landing.component.html',
  styleUrls: ['./header-landing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderLandingComponent implements OnInit {
  public no_logo: boolean = false;

  constructor(
    private router: Router,
    private sStorager: SessionStorageService
  ) {
    this.no_logo =
      !!this.sStorager.getElement(NO_LOGO) &&
      this.sStorager.getElement(NO_LOGO) === 'NO_LOGO';
  }

  ngOnInit(): void {}

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate([ROUTES.PRE_LANDING.path]);
        break;
      }
    }
  }
}
